// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"25281":"1c73507c785b0a55","31073":"9e5544203774da6b","39871":"440766797b3e56ec","48192":"c90a9aafffb5b66e","51739":"18c49a5149530a7d"}[chunkId] + ".css";
};